import ordersApi from '@/api/ordersApi'

function safeParseJson(value) {
  if (!value) return null
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}

function buildReadyTsFromLocalStorage() {
  const selectedDay = safeParseJson(localStorage.getItem('selectedDay'))
  const selectedHour = safeParseJson(localStorage.getItem('selectedHour'))
  if (!selectedDay?.date || !selectedHour?.hour || selectedHour.hour === 'ASAP') return null
  return `${selectedDay.date} ${selectedHour.hour}`
}

export async function recoverGuestOrderAfterLogin(customerId) {
  const rawOrderId = localStorage.getItem('orderId')
  if (!rawOrderId || !customerId) return null

  try {
    const existingOrderResponse = await ordersApi.getOrder(rawOrderId)
    const existingOrderData = existingOrderResponse?.data?.data
    const existingOrder = existingOrderData?.order
    const existingCustomer = existingOrderData?.customer

    // Already attached to an authenticated customer; no fallback needed.
    if (!existingCustomer?.is_guest) {
      return {
        orderData: existingOrderData,
        cookies: existingOrderResponse?.data?.cookies,
        migrated: false,
      }
    }

    const storeId = existingOrder?.store_id || localStorage.getItem('selectedStoreId')
    const serviceTypeId = existingOrder?.service_type_id || Number(localStorage.getItem('selectedServiceId'))
    if (!storeId || !serviceTypeId) return null

    const createOrderPayload = {
      customer_id: Number(customerId),
      store_id: storeId,
      service_type_id: Number(serviceTypeId),
      base_order_id: Number(rawOrderId),
      is_asap: true,
    }

    const readyTs = buildReadyTsFromLocalStorage()
    if (readyTs) {
      createOrderPayload.is_asap = false
      createOrderPayload.ready_ts = readyTs
    }

    if (existingOrder?.address_id) {
      createOrderPayload.address_id = existingOrder.address_id
    }

    const migratedOrderResponse = await ordersApi.createOrder(createOrderPayload)
    let migratedOrderData = migratedOrderResponse?.data?.data
    const migratedOrderId = migratedOrderData?.order?.order_id
    if (migratedOrderId) {
      localStorage.setItem('orderId', String(migratedOrderId))
    }

    let recoveryCookies = migratedOrderResponse?.data?.cookies || existingOrderResponse?.data?.cookies
    const existingTipCents = Number(existingOrder?.charges?.tip_cents || 0)
    const migratedTipCents = Number(migratedOrderData?.order?.charges?.tip_cents || 0)
    if (migratedOrderId && existingTipCents > 0 && migratedTipCents !== existingTipCents) {
      const tipPayload = {
        order: {
          charges: {
            tip_cents: existingTipCents,
          },
        },
      }
      const tipResponse = await ordersApi.addTip(migratedOrderId, tipPayload)
      migratedOrderData = tipResponse?.data?.data || migratedOrderData
      recoveryCookies = tipResponse?.data?.cookies || recoveryCookies
    }

    return {
      orderData: migratedOrderData || existingOrderData,
      cookies: recoveryCookies,
      migrated: true,
    }
  } catch (error) {
    // This is a best-effort Safari/session fallback.
    console.warn('[Auth] Guest order recovery skipped:', error)
    return null
  }
}
